import { useShellState } from "@/hooks/useShellState";
import { ResourceTree } from "./ResourceTree";
import { SidebarNav } from "./SidebarNav";

export function Sidebar() {
  const { sidebarCollapsed } = useShellState();

  return (
    <aside
      className={`flex shrink-0 flex-col border-r border-line bg-sunken transition-[width] duration-150 ${
        sidebarCollapsed ? "w-14" : "w-60"
      }`}
    >
      <nav className="p-2" aria-label="Sections">
        <SidebarNav collapsed={sidebarCollapsed} />
      </nav>
      {!sidebarCollapsed && (
        <>
          <div className="mx-3 my-1 border-t border-line" />
          <div className="min-h-0 flex-1 overflow-auto px-2 pb-4">
            <ResourceTree />
          </div>
        </>
      )}
    </aside>
  );
}
